import React from 'react';
import { Route, Routes } from 'react-router-dom';
import RelationTypesOverview from '../components/RelationTypesOverview';

const RelationTypesScene = () => (
  <Routes>
    <Route
      path=":action?/:id?"
      element={<RelationTypesOverview menuName="relationTypes_plural" />}
    />
  </Routes>
);

export default RelationTypesScene;
